import { useState, useCallback } from 'react';
import { FreeSwitchBlock } from '../types';
import { ApiClient } from '@utils/apiClient';
import { handleApiResult } from '@utils/apiErrorHandler';

export const useFreeSwitchBlocks = () => {
  const [blocks, setBlocks] = useState<FreeSwitchBlock[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchBlocks = useCallback(async () => {
    setLoading(true);
    try {
      const response = await ApiClient.get('/telephony/freeswitch-number-blocks/');
      const result = await handleApiResult<FreeSwitchBlock[]>(response, 'Failed to fetch blocks');
      if (result.success && result.data) {
        setBlocks(result.data.filter(b => b.is_active && b.available_numbers > 0));
      }
    } catch {
      // Fallback: empty list
    } finally {
      setLoading(false);
    }
  }, []);

  return { blocks, loading, fetchBlocks };
};
